import Component, { loader } from "~/routes/catalogo/route";

export { loader };

export default Component;
